import styled from 'styled-components'

export const FileViewerControlsSectionStyled = styled.div`
  grid-area: controls;
  min-width: 0;
`
